module.exports = __webpack_public_path__ + "static/media/Hydropneumatic.45bd9631.png";